"use client";
import { NextIntlClientProvider } from "next-intl";
import type { PropsWithChildren } from "react";

import { AuthSensors } from "@/auth/AuthSensors";
import { AuthOnboardingRoot } from "@/auth/onboarding/AuthOnboardingRoot";
import { SolanaWalletProvider } from "@/auth/WalletProvider";
import { Toaster } from "@/components/ui/Sonner";

import { ReactQueryProvider } from "./ReactQueryProvider";

type AppProvidersProps = PropsWithChildren<{
  messages: Record<string, unknown>;
  locale?: string;
}>;

export const AppProviders = ({
  children,
  messages,
  locale = "en",
}: AppProvidersProps) => (
  <NextIntlClientProvider
    messages={messages}
    locale={locale}
    timeZone="America/New_York"
  >
    <SolanaWalletProvider>
      <ReactQueryProvider>
        <AuthSensors />
        <AuthOnboardingRoot />
        <Toaster />
        {children}
      </ReactQueryProvider>
    </SolanaWalletProvider>
  </NextIntlClientProvider>
);
